<template>
  <div>
    <i class="fa fa-bars sidebar aux-sidebar" @click="toggleSidebar"></i>
    <h1 class="detail-title">Assign the Report Name</h1>

    <div class="row banner">
      <div class="col-sm-3 col-xs-12" style="border-right:1px">
        <report-wizard-navigation></report-wizard-navigation>
      </div>
      <div class="col-sm-9 col-xs-12">
      </div>

    </div>

    <br>
    <div class="form-group col-sm-4">
      <label for="report_name">Report Name</label>
      <input type="text" name="report_name"
             v-model="report_name"
             id="report_name"
             class="form-control"
             v-on:input="$emit('updateReportName', report_name)">
    </div>
  </div>
</template>

<script type="text/javascript">
import CreateCaption from '../CreateCaption';
import ReportWizardNavigation from './ReportWizardNavigation';
import { bus } from '../../main';


export default {
  data() {
    return{
      report_name: '',
    };
  },
  computed: {},
  methods: {
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    }
  },
  components: {
    CreateCaption,
    ReportWizardNavigation,
  }
};
</script>

<style lang="scss" scoped>
.report-nav-container{
  margin-top: -10px;
}
.banner{
    background-color: #06bafc;
    height: 60px;
    color: white;
    margin-right: -25px;
    margin-left: -25px;
    padding-bottom: 10px;
    padding-top: 10px;
    padding-left: 40px;
    margin-top: 0px;
  }
.form-group{
  label{
    margin: inherit;
  }

}
  .aux-sidebar{
    color:white;
    display:none;
  }

  @media (max-width:720px){
    .list-container {
      color:white;

      .row .col-sm-9{
        display:none;
      }
    }
    .detail-title{
      color:white;
      &.detail-title{
        background-color: #04bafc;
      }
      height:52px;
      line-height: 1;
      margin-bottom:0px;
      padding-left: 70px;
      padding-top:10px;
    }
    .aux-sidebar{
      display: block;
      position: absolute;
      top: 10px;
      left: 31px;
      font-size: 150%;
    }

  }
  .form-group{
    min-height: 45vh;
  }


</style>



// WEBPACK FOOTER //
// src/components/report/ReportNameWizard.vue